export class FetchManager {
  constructor() {}

  async setHeaders(data = {}) {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    return header;
  }

  async get(url, data = {}, signal = null) {
    try {
      return await this.executeFetch({ type: "GET", url, data, signal });
    } catch (e) {
      console.error(e);
    }
  }

  async post(url, data = {}, signal = null) {
    try {
      return await this.executeFetch({ type: "POST", url, data, signal });
    } catch (e) {
      console.error(e);
    }
  }

  async patch(url, data = {}, signal = null) {
    try {
      return await this.executeFetch({ type: "PATCH", url, data, signal });
    } catch (e) {
      console.error(e);
    }
  }

  async delete(url, data = {}, signal = null) {
    try {
      return await this.executeFetch({ type: "DELETE", url, data, signal });
    } catch (e) {
      console.error(e);
    }
  }

  download(url, data = {}) {
    try {
      let requestURL = "";
      if (data) {
        for (let key of Object.keys(data)) {
          const value = data[key];
          if (requestURL.length < 1) {
            if (value) requestURL += `?${key}=${value}`;
            else requestURL += `?${key}`;
          } else {
            if (value) requestURL += `&${key}=${value}`;
            else requestURL += `&${key}`;
          }
        }
        url += requestURL;
      }

      window.open(url, "_blank");
      return true;
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * @param {object} config
   * @param {string} config.type
   * @param {string} config.url
   * @param {object} config.data
   * @param {object} config.signal
   */
  async executeFetch(config) {
    try {
      let { type, url, data, signal } = config;
      let requestURL = "";
      if (data && (type === "GET" || type === "DELETE")) {
        for (let key of Object.keys(data)) {
          const value = data[key];
          if (requestURL.length < 1) {
            if (value !== null && value !== undefined)
              requestURL += `?${key}=${value}`;
            else requestURL += `?${key}`;
          } else {
            if (value !== null && value !== undefined)
              requestURL += `&${key}=${value}`;
            else requestURL += `&${key}`;
          }
        }
        url += requestURL;
      }
      let header = await this.setHeaders(data);

      let fetchConfig = {
        method: type,
        mode: "cors",
        headers: header,
        redirect: "follow",
        signal,
      };
      if (this.isEmpty(header)) delete fetchConfig.headers;
      if (
        (type !== "GET" && type !== "DELETE" && Object.keys(data).length) ||
        data instanceof FormData
      ) {
        fetchConfig.body =
          data instanceof FormData ? data : JSON.stringify(data);
      }
      const response = await fetch(url, fetchConfig);
      return response;
    } catch (e) {
      let { url, type } = config;
      console.error(`${url} / ${type} 요청 실패`);
      console.error(e);
    }
  }

  isEmpty(obj) {
    for (let key in obj) return false;
    return true;
  }
}
